import Brick from './Brick';

/** Class representing a workflow brick to
 * create an application.
 *
 * [server_side]
 */
class ApplicationCreateBrick extends Brick {}

export default ApplicationCreateBrick;
